import React, { useState, useEffect, useCallback, useRef, memo } from "react";
import {
  Loader,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";

import ListarInscricoes from "../../../components/Admin/inscricoes";

import { Container,ContentError, Title, SemanticTable } from "./styled";

import swal from "sweetalert";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import Breadcrumb from "../../../components/Admin/Breadcrumb";

import { systemLogs } from "../../../services/system_logs";
import Controls from "./Controls";
import { useRouter } from "../../../hooks/router";

const PaginaListar = () => {
  const [search, setSearch] = useState("");
  const [searchPedido, setSearchPedido] = useState("");
  const [pedidos, setPedidos] = useState([]);
  const [pagina, setPagina] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [idCurso, setIdCurso] = useState();

  const router = useRouter();

  const updateQueryParams = useCallback(
    (queryParams) => {
      const pathname = router.pathname;
      const queryString = `${new URLSearchParams(queryParams)}`;

      router.replace(`${pathname}?${queryString}`);
    },
    [router]
  );

  const handleQueryParams = useCallback(
    (filters) => {
      const rawQueryParams = objectCamelToKebab(filters);

      const queryParams = cleanObject(rawQueryParams, {
        removeEmptyStrings: true,
      });

      updateQueryParams(queryParams);
    },
    [updateQueryParams]
  );

  const initialLoad = useCallback(() => {
    const {
      "id-pedido": idPedido,
      "id-curso": idCurso,
      "nome-pessoa": nomePessoa,
      page,
    } = router.query;

    setSearchPedido(idPedido);
    setIdCurso(idCurso);
    setSearch(nomePessoa);
    setPagina(page);

    loadPedidos({ idPedido, idCurso, nomePessoa, page });
  }, [router]);

  useEffect(() => {
    initialLoad();
  }, []);

  const cleanObject = (data, options = { removeEmptyStrings: false }) => {
    const { removeEmptyStrings } = options;

    return Object.keys(data)
      .filter(
        (key) =>
          data[key] !== null &&
          data[key] !== undefined &&
          (!removeEmptyStrings || data[key] !== "")
      )
      .reduce((sum, key) => ({ ...sum, [key]: data[key] }), {});
  };

  const camelToKebab = (str) => {
    if (!str) {
      return "";
    }

    const formatedStr = str[0].toLowerCase() + str.slice(1);

    return formatedStr.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  };

  const objectCamelToKebab = (obj) => {
    return Object.entries(obj).reduce((sum, [key, value]) => {
      sum[camelToKebab(key)] = value;
      return sum;
    }, {});
  };

  /**
   * Load Pedidos definition
   * @param {Object} filters
   * @param {string} filters.nomePessoa
   * @param {string} filters.idCurso
   * @param {string} filters.idPedido
   * @param {number} filters.page
   */

  const loadPedidos = useCallback(
    async (filters = {}) => {
      setLoading(true);

      try {
        const formatedFilters = {
          idPedido: filters.idPedido || searchPedido,
          idCurso: filters.idCurso || idCurso,
          nomePessoa: filters.nomePessoa || search,
          page: filters.page || pagina || 1,
        };

        const params = objectCamelToKebab(formatedFilters);

        const {
          data: { items, page, pages },
        } = await api.get("pedido", { params });

        setPedidos(items);
        setPagina(page);
        setPages(pages);
        setLoading(false);
        handleQueryParams(formatedFilters);
        await systemLogs("inscricoes", "listou as inscricoes");
      } catch (err) {
        console.error(err);
        setLoading(false);
        swal("Não foi possível carregar os pedidos", err, "");
      }
    },
    [handleQueryParams, searchPedido, idCurso, search, pagina]
  );

  const handlePageChange = useCallback(
    async (event, rawPage) => {
      const newPage = rawPage > 0 ? rawPage : 1;

      if (Number(newPage) === Number(pagina)) {
        return;
      }

      setPagina(newPage);

      loadPedidos({ page: newPage });
    },
    [pagina]
  );

  const handleStatus = async (valor, id_pedido) => {
    try {
      await api.put(`admin/pedido/admin-inscricoes/${id_pedido}`, { status: valor });

      await systemLogs(
        "inscricoes",
        `atualizou o status do pedido de id_pedido=${id_pedido}`
      );
      loadPedidos();
      swal("Status editado com sucesso", "", "success");
      setLoading(false)
    } catch (err) {
      console.error(err);
      swal("Não foi possível editar os status", err, "");
    }
  };

  const handleEdit = async (pessoaCurso) => {

    try {
      const payload = {
        status: pessoaCurso.status,
        valor_pago: pessoaCurso.valor_pago,
        pgto01: pessoaCurso.pgto01,
        forma01: pessoaCurso.forma01,
        dataPagto01: pessoaCurso.dataPagto01,
        pgto02: pessoaCurso.pgto02,
        forma02: pessoaCurso.forma02,
        dataPagto02: pessoaCurso.dataPagto02,
        pgto03: pessoaCurso.pgto03,
        forma03: pessoaCurso.forma03,
        dataPagto03: pessoaCurso.dataPagto03,
        pgto04: pessoaCurso.pgto04,
        forma04: pessoaCurso.forma04,
        dataPagto04: pessoaCurso.dataPagto04,
        observacao: pessoaCurso.observacao,
        MaterialImpresso: pessoaCurso.MaterialImpresso,
        CertificadoImpresso: pessoaCurso.CertificadoImpresso,
      };
      setLoading(true);
      await api.put(
        `admin/pedido/admin-inscricoes/${pessoaCurso.id_pedido}`,
        payload
      );
      handleStatus(3, pessoaCurso.id_pedido);

      await systemLogs(
        "inscricoes",
        `editou o pedido de id_pedido=${pessoaCurso.id_pedido}`
      );

    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar os pedidos", err, "");
      setLoading(false);
    }
  };
  const handleValue = useCallback(
    (index, value) => {
      const newPedidos = [...pedidos];
      newPedidos[index] = value;

      setPedidos(newPedidos);
    },
    [pedidos]
  );

  const handleDel = useCallback(
    async (valor) => {
      try {
        setLoading(true);
        const newPedidos = [...pedidos].filter((ped) => ped.id !== valor);
        setPedidos(newPedidos);

        await api.delete(`admin/pedido/admin-inscricoes/${valor}`);

        await systemLogs("inscricoes", `deletou o pedido de id=${valor}`);
        swal("Pedido deletado com sucesso", "", "success");
        setLoading(false);
        cleanSearch();
      } catch (err) {
        console.error(err);
        swal("Não foi possível deletar os pedidos", err, "");
      }
    },
    [pedidos]
  );

  const cleanSearch = () => {
  setSearch("");
  setSearchPedido("");
  loadPedidos();
  }

  const doSearchIdPedido = useCallback(() => {
    loadPedidos({ idPedido: searchPedido });
  }, [searchPedido, loadPedidos]);

  const cleanSearchIdPedido = () => {
    setSearchPedido("");
    loadPedidos();
  };

  const doSearchNomePessoa = useCallback(() => {
    loadPedidos({ nomePessoa: search });
  }, [search, loadPedidos]);

  const doSearchEmpty = async () => {


    setSearchPedido("");
    setIdCurso("");
    setSearch("");
    setPagina(1);

    setLoading(true);
    try {
      const payload = {
        idPedido: "",
        idCurso: "",
        nomePessoa: "",
        page:1,
      };
      const params = objectCamelToKebab(payload);

      const {
        data: { items, page, pages },
      } = await api.get("pedido", { params });

      setPedidos(items);
      setPagina(page);
      setPages(pages);
      setLoading(false);
      handleQueryParams(payload);
    } catch (err) {
      console.error(err);
      setLoading(false);
      swal("Não foi possível carregar os pedidos", err, "");
    }

  };

  const cleanSearchNomePessoa = () => {
    setSearch("");
    loadPedidos();
  };

  const handleIdCurso = useCallback(
    (idCurso) => {
      setIdCurso(idCurso);
      loadPedidos({ idCurso });
    },
    [loadPedidos]
  );

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />

      <Container>
        <Breadcrumb
          sections={[
            {
              key: 0,
              content: "Painel de Controle",
              href: "/admin/",
            },
            { key: 1, content: "Inscrições", active: true },
          ]}
        />

        <Title>Inscrições Ativas</Title>

        <Controls
          page={pagina}
          pages={pages}
          handlePageChange={handlePageChange}
          nomePessoa={search}
          setNomePessoa={setSearch}
          doSearchNomePessoa={doSearchNomePessoa}
          cleanSearchNomePessoa={cleanSearchNomePessoa}
          setIdCurso={handleIdCurso}
          idCurso={idCurso}
          idPedido={searchPedido}
          setIdPedido={setSearchPedido}
          doSearchIdPedido={doSearchIdPedido}
          cleanSearchIdPedido={cleanSearchIdPedido}
        />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : pedidos.length > 0 ? (
          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell style={{ width: "8%" }} >Id Pedido</SemanticTable.HeaderCell >
                <SemanticTable.HeaderCell style={{ width: "10%" }}>Data Insc.</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Dados</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Financeiro</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell style={{ width: "10%" }}>Pagamento</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell style={{ width: "10%" }}>
                  Controle
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>

            <SemanticTable.Body>
              {pedidos.map((pedido, index) => (
                <ListarInscricoes
                  key={index}
                  handleEdit={handleEdit}
                  handleStatus={handleStatus}
                  handleDel={handleDel}
                  value={pedido}
                  setValue={(value) => handleValue(index, value)}
                />
              ))}
            </SemanticTable.Body>
          </SemanticTable>
        ): (<ContentError>
          <p>Sem resposta!</p>
          <button onClick={() => doSearchEmpty()}>Retornar</button>
          </ContentError>)}

        {/* <Controls
          page={pagina}
          pages={pages}
          handlePageChange={handlePageChange}
          nomePessoa={search}
          setNomePessoa={setSearch}
          doSearchNomePessoa={doSearchNomePessoa}
          cleanSearchNomePessoa={cleanSearchNomePessoa}
          setIdCurso={handleIdCurso}
          idCurso={idCurso}
          idPedido={searchPedido}
          setIdPedido={setSearchPedido}
          doSearchIdPedido={doSearchIdPedido}
          cleanSearchIdPedido={cleanSearchIdPedido}
          reverse
        /> */}
      </Container>
    </div>
  );
};

export default PaginaListar;
